module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"container-fluid data\">\n<div class=\"row\">\n<div class=\"col p-0\">\n<div class=\"container-fluid wrap\">\n<div class=\"row\">\n<div class=\"col-sm-4\"><div class=\"title\"><%= model.addressTitle %></div><div class=\"field\"><%- model.address %></div></div>\n<div class=\"col-sm-4\"><div class=\"title\"><%= model.mailTitle %></div><div class=\"field\"><a href=\"mailto:<%= model.mail %>\"><%= model.mail %></a></div></div>\n<div class=\"col-sm-4\"><div class=\"title\"><%= model.openingHoursTitle %></div><div class=\"field\"><%- model.openingHours %></div></div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"container-fluid footer\">\n<div class=\"row\">\n<div class=\"col p-0\">\n<div class=\"container-fluid wrap\">\n<div class=\"row\">\n<div class=\"col-md-12\">\n<div class=\"title\"><%= model.impressumTitle %></div>\n<nav><ul><%- helpers.renderNavRoutesByCode(resourceData, 'footer') %></ul></nav>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  , __filename = "components\\templates\\footer\\footer.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"container-fluid data\">\n<div class=\"row\">\n<div class=\"col p-0\">\n<div class=\"container-fluid wrap\">\n<div class=\"row\">\n<div class=\"col-sm-4\"><div class=\"title\">")
    ; __line = 6
    ; __append(escapeFn( model.addressTitle ))
    ; __append("</div><div class=\"field\">")
    ; __append( model.address )
    ; __append("</div></div>\n<div class=\"col-sm-4\"><div class=\"title\">")
    ; __line = 7
    ; __append(escapeFn( model.mailTitle ))
    ; __append("</div><div class=\"field\"><a href=\"mailto:")
    ; __append(escapeFn( model.mail ))
    ; __append("\">")
    ; __append(escapeFn( model.mail ))
    ; __append("</a></div></div>\n<div class=\"col-sm-4\"><div class=\"title\">")
    ; __line = 8
    ; __append(escapeFn( model.openingHoursTitle ))
    ; __append("</div><div class=\"field\">")
    ; __append( model.openingHours )
    ; __append("</div></div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"container-fluid footer\">\n<div class=\"row\">\n<div class=\"col p-0\">\n<div class=\"container-fluid wrap\">\n<div class=\"row\">\n<div class=\"col-md-12\">\n<div class=\"title\">")
    ; __line = 20
    ; __append(escapeFn( model.impressumTitle ))
    ; __append("</div>\n<nav><ul>")
    ; __line = 21
    ; __append( helpers.renderNavRoutesByCode(resourceData, 'footer') )
    ; __append("</ul></nav>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>")
    ; __line = 27
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components\templates\footer\footer.ejs

}